import {
  ArbitrumTokenAddress,
  BaseTokenAddress,
  MainnetTokenAddress,
  OptimismTokenAddress,
} from "@silo/addresses";
import {
  ChainIdLegacy,
  ChecksumAddress,
  SupportedChainId,
  SupportedChainValue,
  createChainValueGetter,
} from "@silo/types";

export const isWrappedNativeToken =
  (chainId: SupportedChainId) => (tokenAddress: ChecksumAddress) =>
    NATIVE_TOKEN[chainId].wrappedAddress === tokenAddress;

export const getWrappedNativeTokenAddress = (chainId: SupportedChainId) =>
  NATIVE_TOKEN[chainId].wrappedAddress;

interface NativeToken {
  name: string;
  symbol: string;
  decimals: number;
  wrappedAddress: ChecksumAddress;
}

const mainnetNativeToken: NativeToken = {
  name: "Ether",
  symbol: "ETH",
  decimals: 18,
  wrappedAddress: MainnetTokenAddress.WETH,
};

export const NATIVE_TOKEN: SupportedChainValue<NativeToken> = {
  [ChainIdLegacy.MAINNET]: mainnetNativeToken,
  [ChainIdLegacy.ARBITRUM]: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18,
    wrappedAddress: ArbitrumTokenAddress.WETH,
  },
  [ChainIdLegacy.OPTIMISM]: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18,
    wrappedAddress: OptimismTokenAddress.WETH,
  },
  [ChainIdLegacy.BASE]: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18,
    wrappedAddress: BaseTokenAddress.WETH,
  },
  [ChainIdLegacy.LOCAL]: mainnetNativeToken,
  [ChainIdLegacy.ANVIL]: mainnetNativeToken,
};

/**
 * @deprecated temporary symbol solution
 */
export const getTokenSymbol = (
  chainId: ChainIdLegacy | undefined,
  tokenAddress: ChecksumAddress,
  symbol: string
) => {
  // TODO: name & symbol branded type fix
  if (
    chainId === ChainIdLegacy.ARBITRUM &&
    tokenAddress === ArbitrumTokenAddress.USDC_e
  ) {
    // WARNING: keep @silo/config value in sync
    return "USDC.e";
  }

  const nativeToken = getNativeToken(chainId);

  if (nativeToken.wrappedAddress === tokenAddress) return nativeToken.symbol;

  return symbol;
};

/**
 * @deprecated temporary name solution
 */
export const getTokenName = (
  chainId: ChainIdLegacy | undefined,
  tokenAddress: ChecksumAddress,
  name: string
) => {
  // TODO: name & symbol branded type fix
  if (
    chainId === ChainIdLegacy.ARBITRUM &&
    tokenAddress === ArbitrumTokenAddress.USDC_e
  ) {
    // WARNING: keep @silo/config value in sync
    return "Bridged USDC";
  }

  const nativeToken = getNativeToken(chainId);

  if (nativeToken.wrappedAddress === tokenAddress) return nativeToken.name;

  return name;
};

/**
 * @deprecated Use `NATIVE_TOKEN` with supported chain id instead
 */
export const getNativeToken = createChainValueGetter(
  mainnetNativeToken,
  NATIVE_TOKEN
);
